export default
{
    name: 'app-page-transition',

    props:
    {
        isActive:
        {
            type: Boolean,
            default: false
        }
    },

    data()
    {
        return {

        }
    },

    created()
    {

    },

    mounted()
    {

    },

    destroyed()
    {

    },

    methods:
    {

    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-transition/script.js